import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from '@ux/component-utilities/lib/classNames';

const DEFAULT_ARIA_LABELS = {
  spinnerName: 'Your content is loading'
};

/**
 * Display a spinner.
 *
 * @displayName Spinner (Web)
 * @class Spinner
 * @public
 */
export default class Spinner extends Component {
  /**
   * Render the actual component.
   *
   * @returns {Component} The actual spinner component.
   * @private
   */
  render() {
    const { size, ariaLabels, className } = this.props;
    const classes = classNames('ux-spinner', className, {
      [`ux-spinner-${size}`]: size
    });

    return (
      <svg className={ classes } aria-label={ ariaLabels.spinnerName } xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 72'>
        <circle className='bg-spinner' cx='36' cy='36' r='31' fill='none' startOffset='0' />
        <circle className='fg-spinner'  cx='36' cy='36' r='31' fill='none'  />
      </svg>
    );
  }
}

Spinner.propTypes = {
  /** Classes to be applied to the spinner */
  className: PropTypes.string,
  /** Defines the size of the spinner */
  size: PropTypes.PropTypes.oneOf(['sm', 'md', 'lg']).isRequired,
  /** Screenreader labels for sub-elements */
  ariaLabels: PropTypes.shape({
    /** Screen reader label for spinner */
    spinnerName: PropTypes.string
  })
};

/**
 * Default properties.
 *
 * @type {Object}
 * @private
 */
Spinner.defaultProps = {
  size: 'md',            // Default size.
  ariaLabels: DEFAULT_ARIA_LABELS,
  ...{ className: 'spin-center' }
};
